import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'behavior',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    ReactiveFormsModule
  ],
  templateUrl: './behavior.component.html',
  styleUrl: './behavior.component.css'
})
export class BehaviorComponent implements OnInit, OnChanges {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection4 = new EventEmitter<any>();

  yesNo = EYesNo;
  hebahaviorForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Have you experienced or observed behavior problems or changes in behavior with this student? *",
      formControlName: "observed_behavior_problems",
    },
    {
      question: "How does this student respond to being corrected by an adult? *",
      formControlName: "adult_correction",
    }
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teacherStaffInterviewData'] && this.teacherStaffInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.teacherStaffInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.hebahaviorForm = new FormGroup(group);
  }

  saveBehavior(): void {
    if (this.hebahaviorForm.valid) {
      this.onSaveSection4.emit(this.hebahaviorForm.value);
    }
  }

}
